import DataStore from './DataStore';
import Utils from '../common/Utils';
import MainBanner from './components/MainBanner';
import SubBanner from './components/SubBanner';
import Hotkeyword from '../common/components/Hotkeyword';
import Recommend from './components/Recommend';
import StateBanner from './components/StateBanner';
import CharacterInfo from './components/CharacterInfo';
import SpecialBanner from './components/SpecialBanner';
import Notice from "./components/Notice";
import GMContents from "./components/GMContents";
import CardList from "./components/CardList";
import ServerIntergrationBanner from "./components/ServerIntergrationBanner";



/**
 * main의 시작점..
 * @category main
 * @memberof module:main
 * @param  {Object} _config={} 설정 옵션
 * @param  {Object} _config.apiDomain="" api Domain
 * @param  {Object} _config.apiBoardDomain="" api Board Domain..
 * @example
 * var testApp = new nc.lineage2.sampleApp({
 *      apiDomain: 'https://api-lineage2.plaync.com',
 *      isLogin: true
 * });
 */
class App{
    constructor(_config={}){
        this.store = new DataStore(_config);
        this.selector = '#container'; 

        this.store.getData('config', {}, (d) => console.log( 'config---',  d ) );

        this.init();
       
    }

    async init(){
        await this.store.getDataContiGroup({
            'main-news': 'mainNotices',
            'main-gmcontents': 'mainGMcontents',
            'main-section1': 'mainCardlist1',
            'main-section2': 'mainCardlist2',
            'main-section3': 'mainCardlist3',
            'main-section4': 'mainCardlist4',
            'main-promotion': 'mainBanner',
            'main-server-integration': 'serverIntegration',
            'main-subbanner': 'subBanner'
        });

        this.mainBanner = new MainBanner(this.store, this.selector + ' .main-banner'); // [클라이언트 렌더링]
        // this.hotkeyword = new Hotkeyword(this.store.getData('Hotkeyword'), this.selector + ' .hotkeyword', 'bottom');
        this.recommend = new Recommend(this.store, this.selector + ' .recommended-product'); // [서버 렌더링] - 사용안함
        this.stateBanner = new StateBanner(this.store, this.selector + ' .state-banner-wrap'); // [서버 렌더링]
        this.charInfo = new CharacterInfo(this.store, this.selector + ' .character-info-wrap'); // [클라이언트 렌더링]
        this.spBanner = new SpecialBanner(this.store, this.selector + ' .special-banner-wrap'); // [서버 렌더링]
        this.notice = new Notice(this.store, this.selector + ' .notice-templ'); // [클라이언트 렌더링]
        // this.gmContents = new GMContents(this.store, this.selector + ' .gmcontents-templ'); // [클라이언트 렌더링]
        this.cardList1 = new CardList(this.store, this.selector + ' .cardlist1-templ', 'mainCardlist1'); // [클라이언트 렌더링]
        this.cardList2 = new CardList(this.store, this.selector + ' .cardlist2-templ', 'mainCardlist2'); // [클라이언트 렌더링]
        this.cardList3 = new CardList(this.store, this.selector + ' .cardlist3-templ', 'mainCardlist3'); // [클라이언트 렌더링]
        this.cardList4 = new CardList(this.store, this.selector + ' .cardlist4-templ', 'mainCardlist4'); // [클라이언트 렌더링]
        this.serverIntergrationBanner = new ServerIntergrationBanner(this.store, this.selector + ' .server-integration', 'serverIntegration'); // [클라이언트 렌더링]

        this.subBanner = new SubBanner(this.store, this.selector + ' .subbanner-wrap'); // [클라이언트 렌더링]
        // 2021.06.30 6단->4단으로 콘텐트 축소
        //this.cardList5 = new CardList(this.store, this.selector + ' .cardlist5-templ', 'mainCardlist5');
        //this.cardList6 = new CardList(this.store, this.selector + ' .cardlist6-templ', 'mainCardlist6');
    }
}

Utils.namespace('nc.lineage2.main');
nc.lineage2.main = App;

// new nc.lineage2.main();